module.exports = __webpack_public_path__ + "static/img/Elliott-Whitehead.01563f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Elliott-Whitehead.jpg
// module id = JqM2
// module chunks = 0